export const ADD_BUNDLES = 'ADD_BUNDLES'
export const ADD_BUNDLE = 'ADD_BUNDLE'
export const SET_IMAGE_BUNDLE = 'SET_IMAGE_BUNDLE'
export const LOAD_APPLIES = 'LOAD_APPLIES'
export const LOAD_TYPES = 'LOAD_TYPES'